import {
   getCompanyRules, updateSortRule as update, storeSortRule as store, getRuleDefinitions,
} from '@/api/sort';

export function fetchCompanyRules({ commit, getters }, slug) {
   return new Promise(resolve => {
      if (getters.isFetching(slug)) {
         resolve();
         return;
      }
      console.log('fetch start');
      commit('fetchingStarted', slug);
      getCompanyRules(slug).then(rules => {
         commit('setCompanyRules', { slug, rules });
         resolve();
      }).finally(() => {
         commit('fetchingFinished', slug);
         console.log('done');
      });
   });
}

export function fetchRuleDefinitions({ commit }) {
   return new Promise(resolve => {
      getRuleDefinitions().then(definitions => {
         commit('setDefinitions', definitions);
         resolve();
      });
   });
}

export function updateSortRule({ commit }, { slug, id, updates }) {
   return new Promise(resolve => {
      commit('updatingStarted', id);
      update(id, updates).then(updated => {
         commit('insertOrUpdateCompanyRule', { slug, rule: updated });
         resolve();
      }).finally(() => {
         commit('updatingFinished', id);
      });
   });
}

export function storeSortRule({ commit }, { slug, rule }) {
   return new Promise(resolve => {
      store(slug, rule).then(stored => {
         commit('insertOrUpdateCompanyRule', { slug, rule: stored });
         resolve();
      });
   });
}
